import React, { useEffect } from 'react'
import { Chip, LinearProgress, Snackbar, Fade } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import MaterialTable from 'material-table'
import useProfiles from '../../hooks/modules/profile/useProfiles'
import useStyles from '../../hooks/useStyles'
import { Strings } from '../../assets/res/en'
import { SearchBar } from '../../components/searchBox/SearchBar'
import useTableIcons from '../../hooks/useTableIcons'
import { ModalDialog, ToolBar } from '../../components/tools'
import Unauthorized from '../../components/Unauthorized'

export default function Profiles() {
    const classes = useStyles()
    const { tableIcons } = useTableIcons()
    const {
        profiles,
        isLoading,
        getAllProfiles,
        searchOptions,
        columns,
        sytlingOptions,
        actions,
        filters,
        searchData,
        openDialog,
        handleModalClose,
        handleActionClick,
        modalHeader,
        modalContent,
        modalActions,
        modalFormResetKeys,
        modalTaskRunning,
        modalFormError,
        profilePermission,
        showPermissionReminder,
        closePermissionReminder
    } = useProfiles()

    useEffect(() => {
        getAllProfiles()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            {
                profilePermission.read === true ?
                    <>
                        <SearchBar options={searchOptions} />
                        <MaterialTable
                            title={Strings.COLUMN_PROFILE_TITLE}
                            icons={tableIcons}
                            columns={columns}
                            actions={actions}
                            data={profiles}
                            options={sytlingOptions}
                            isLoading={isLoading}
                            localization={{ body: { editRow: { deleteText: Strings.COLUMN_PROFILE_DELETE_TEXT } } }}
                            components={{
                                Toolbar: props => (
                                    <div>
                                        <ToolBar {...props} onAction={handleActionClick} canCreate={profilePermission.create ?? false} />
                                        <div className={filters.filter(item => item.value && item.value.toString().trim() !== '').length > 0 ? classes.filterContainer : ""}>
                                            {
                                                filters.filter(item => item.value && item.value.toString().trim() !== '').length > 0 &&
                                                filters.filter(item => (item.value && item.value.toString().trim() !== '') || item.isClearAll === true).map(fItem => (
                                                    fItem.isClearAll === true ?
                                                        <Chip key={fItem.name} color="secondary" label="Reset All Filters" onClick={() => fItem.clearAll(filters)} /> :
                                                        <Chip key={fItem.name} color="default" label={fItem.value} onDelete={() => fItem.remove(fItem, filters, searchData)} />))
                                            }
                                        </div>
                                    </div>
                                )
                            }}
                        />
                        <ModalDialog open={openDialog}
                            handleClose={handleModalClose}
                            modalHeader={modalHeader}
                            modalContent={modalContent}
                            modalActions={modalActions}
                            modalFormResetKeys={modalFormResetKeys}
                            modalTaskRunning={modalTaskRunning}
                            modalFormError={modalFormError} />
                        <Snackbar
                            open={showPermissionReminder}
                            autoHideDuration={4000}
                            onClose={closePermissionReminder}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            TransitionComponent={Fade}
                            transitionDuration={{ enter: 300, exit: 1000 }}
                        >
                            <Alert
                                severity="success"
                                variant="filled"
                                icon={<tableIcons.Permission fontSize="inherit" />}
                                onClose={closePermissionReminder}
                                style={{ backgroundColor: '#2e7d32', color: '#fff' }}
                            >
                                Don't forget to Edit Permissions
                            </Alert>
                        </Snackbar>
                    </>
                    : profilePermission.read === false ?
                    <Unauthorized />:
                    <LinearProgress/>
            }
        </>
    )
}